import { useEffect } from 'react';

declare global {
	interface Window {
		googletag: any;
	}
}

export function useLoadScript() {
	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
		script.crossOrigin = 'anonymous';
		script.async = true; // or false for synchronous loading
		document.body.appendChild(script);

		return () => {
			// Clean up: remove the script when the component unmounts
			document.body.removeChild(script);
		};
	}, []);
}

export function useAd({ slot, sizes, id }: AdArgs) {
	useEffect(() => {
		window.googletag = window.googletag || { cmd: [] };
		window.googletag.cmd.push(function() {
			window.googletag
				.defineSlot(slot, sizes, id)
				.addService(window.googletag.pubads());
			window.googletag.pubads().enableSingleRequest();
			window.googletag.enableServices();
			setTimeout(() => {
				window.googletag.cmd.push(function() {
					window.googletag.display(id);
				});
			}, 1000);
		});
	}, []);
}

interface AdArgs {
	slot: string;
	sizes: Array<Array<number>>;
	id: string;
}
